export default __webpack_public_path__ + "static/media/live1.b6a7c820.jpeg";